import { formatCardNumber, validCardNumber } from './creditCardHelper'

export const validateName = (value) => {
  return value === null ||
    value.toString().replace(/\t|\s|\n|\r/g, '').length < 1
    ? 'Required'
    : undefined
}

export const validatePhone = (value) => {
  if (!value) return undefined

  let phone = undefined
  let phoneDigits = value.match(/\d+/g)
  if (phoneDigits) {
    phone = phoneDigits.join('')
  } else {
    return undefined
  }
  if (phone.length !== 10) return 'Phone number should be 10 digits'
}

export const validateEmail = (value) => {
  if (!value) return undefined

  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value))
    return 'Invalid email'
}

export const validateCardNumber = (value) => {
  if (!value) return undefined

  let n = value.match(/\d+/g).join('')
  return !validCardNumber(n) ? 'Card Number appears to be invalid' : undefined
}

export const normalizePhone = (value) => {
  if (!value) return value

  const n = value.replace(/[^\d]/g, '')

  if (n.length <= 3) return n
  else if (n.length <= 6) return `(${n.slice(0, 3)}) ${n.slice(3)}`

  return `(${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6, 10)}`
}

export const normalizeName = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const normalizeCardExpiration = (value) => {
  if (value == null) return value

  let n = value.replace(/[^\d]/g, '')

  if (n.length <= 2) return n

  return `${n.slice(0, 2)}/${n.slice(2, 4)}`
}

export const normalizeCardCode = (value) => {
  if (value == null) return value

  let n = value.replace(/[^\d]/g, '')

  return n.slice(0, 4)
}

export const normalizeCardNumber = (value) => {
  if (!value) return value

  let val = value.replace(/[^\d]/g, '').slice(0, 16)
  return formatCardNumber(val)
}

export const escapeRegexCharacters = str => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
